import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AccountsApi } from '../../apis';
import { UpdateAccount } from '../../models/accounts';
import { QueryKeys } from '../query-keys';

const useUpdateAccount = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (account: UpdateAccount) => AccountsApi.update(account),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.ACCOUNTS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.TRANSACTIONS] });
    },
  });

  return {
    updateAccount: mutation.mutateAsync,
    isUpdating: mutation.isPending,
    wasUpdatedWithSuccess: mutation.isSuccess,
    wasUpdatedWithoutSuccess: mutation.isError,
  };
};

export default useUpdateAccount;
